<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "Write your reason here",
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  "update:modelValue",
  "focus",
  "blur",
  "input",
  "click",
]);

const textValue = ref(props.modelValue);

const handleInput = () => {
  emit("update:modelValue", textValue.value);
  emit("input", textValue.value);
};

const handleBlur = () => {
  emit("blur", textValue.value);
};

const handleFocus = () => {
  emit("focus", textValue.value);
};

const handleClick = () => {
  emit("click");
};
</script>

<template>
  <div
    :class="['textarea-option', isSelected && 'textarea-option-active']"
    @click="handleClick"
  >
    <div :class="['section-title', isSelected && 'section-title-active']">
      {{ label }}
    </div>
    <div :class="['textarea-wrapper', isSelected && 'textarea-wrapper-active']">
      <textarea
        v-model="textValue"
        :placeholder="placeholder"
        class="custom-textarea"
        @input="handleInput"
        @blur="handleBlur"
        @focus="handleFocus"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.textarea-option {
  display: flex;
  flex-direction: column;
  border: 1px solid $pj-color-light-gray;
  border-radius: 5px;
  margin-top: 12px;
  padding: 20px 16px;
  max-height: 67px;
  transition: all 0.3s ease;
}

.textarea-option-active {
  border: 1px solid #007c3b;
  max-height: 164px;
}

.section-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 26px;
  color: $pj-color-black;
  margin: 0;
  padding-bottom: 4px;
  border-bottom: 1px solid transparent;
}

.section-title-active {
  border-bottom: 1px solid $pj-color-light-gray;
}

.textarea-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  opacity: 0;
}

.custom-textarea {
  width: 100%;
  min-height: 100px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: $pj-color-black;
  background-color: $pj-color-white;
  resize: vertical;
  transition: border-color 0.2s ease;
  border: none;
  &::placeholder {
    color: $pj-color-sub-gray;
    font-weight: 400;
    opacity: 1;
    size: 14px;
    line-height: 26px;
  }

  &:focus {
    outline: none;
    border-color: $pj-color-black;
  }

  &:hover {
    border-color: $pj-color-border-gray;
  }
}

.textarea-wrapper-active {
  opacity: 1;
}
</style>
